import { memo, ReactNode } from 'react';
import { Stack, Typography, SxProps, Theme } from '@mui/material';
import { ResponsiveStyleValue } from './DialogTextField';

interface IGenericProps {
  label?: string;
  labelWidth?: number | string;
  marginBottom?: string;
  children: ReactNode;
  stackDirection?: ResponsiveStyleValue<'row' | 'row-reverse' | 'column' | 'column-reverse'>;
  labelSx?: SxProps;
  stackSx?: SxProps;
}

function DialogGeneric({
  label,
  labelWidth = '100px',
  marginBottom = '8px',
  stackDirection = { xs: 'column', sm: 'column', md: 'row' },
  children,
  labelSx = {},
  stackSx = {},
}: IGenericProps): JSX.Element {
  const labelStyle: SxProps<Theme> = {
    color: 'mind.black.A0',
    minWidth: labelWidth,
    maxWidth: labelWidth,
    typography: 's13w800',
  };
  return (
    <Stack
      sx={{ marginBottom, marginTop: '1px', ...stackSx }}
      spacing="8px"
      direction={stackDirection}
      alignItems="center"
    >
      {label && (
        <Typography
          sx={{
            ...labelStyle,
            ...labelSx,
            maxWidth: { xs: '100%', sm: '100%', md: labelWidth },
            width: { xs: '100%', sm: '100%', md: labelWidth },
          }}
          noWrap
        >
          {label}
        </Typography>
      )}
      {children}
    </Stack>
  );
}

export default memo(DialogGeneric);
